// Measurement path for the Google tag gateway (first-party serving of GTM/GA4).
// Requests to this path are proxied to https://<gtm-id>.fps.goog by middleware.ts,
// and the GTM bootstrap snippet in _app.tsx loads gtm.js from it.
export const TAG_GATEWAY_PATH = '/metrics';
